import { useStore } from 'jotai';
import { useCallback } from 'react';

import { isSidePanelOpenState } from '@/ui/layout/side-panel/states/isSidePanelOpenState';

export const useCloseSidePanel = () => {
  const store = useStore();

  const closeSidePanel = useCallback(() => {
    store.set(isSidePanelOpenState.atom, false);
  }, [store]);

  return { closeSidePanel };
};
